// extracted by mini-css-extract-plugin
export default {"item":"card_item__akGAU","link":"card_link__mMSeY","price":"card_price__HuegY","name":"card_name__JkQzz"};